import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IModuleFormModel, IParametricControl, IValidatorModel, InputTypeEnum } from '@types-custom/models/ui/generic-form.model';


@Component({
  selector: 'module-form',
  templateUrl: './module-form.component.html',
  styleUrls: ['./module-form.component.scss'],
})
export class ModuleFormComponent implements OnInit {

  @Input() properties: IModuleFormModel<any[]>;

  formModelArray: IParametricControl[][] = [];

  get InputType() {
    return InputTypeEnum;
  }

  ngOnInit(): void {
    this.formModelArray = [...(this.properties.formModel ?? [])]; //Creates a copy or an empty array
    this._createFormControls();
  }

  private _createFormControls() {
    this.properties.formModel.forEach(cg => {
      cg.forEach((c) => this.initializeControl(c));
    });
  }

  private initializeControl(ctrl: IParametricControl) {
    this.handleInitControlByType(ctrl);
    this.properties.formGroup.addControl(ctrl.key,
      new FormControl(
        ctrl.formControl.value, {
        ...ctrl.formControl.options,
        validators: (ctrl.formControl.validators?.map((ele: IValidatorModel) => ele.validator) ?? []),
      }));
  }

  private handleInitControlByType(ctrl: IParametricControl) {
    switch (ctrl.type) {
      case InputTypeEnum.SELECT:
      case InputTypeEnum.BUTTON_RADIO:
        this.properties.serviceDataSource.getSelectOptions(ctrl.listType).subscribe(
          l => ctrl.list = l
        );
        break;
      default:
        break;
    }
  }

  _validateControl(controlInfo: any, validator: IValidatorModel): boolean {
    const control = this.properties.formGroup.get(controlInfo.formKey);
    return control?.touched && control?.hasError(validator.validatorCodeName);
  }
}
